import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import PoolAccessGuard from '../auth/PoolAccessGuard';
import CctvPoolMonitoringPopupPage from '../../pages/CctvMonitoringPopupPage';
import { CCTV_POPUP_RESERVED_SEGMENTS } from '../monitoring/cctvPopupRoutes';

type Params = {
  poolCode: string;
  mode: string;
};

/**
 * /:poolCode/grid | /:poolCode/rotation 전용 — 다른 앱 경로와 충돌하지 않도록 검증
 */
const CctvShortPoolPopupRoute: React.FC = () => {
  const { poolCode, mode } = useParams<Params>();

  if (!poolCode || !mode) {
    return <Navigate to="/central-control" replace />;
  }

  const decoded = decodeURIComponent(poolCode);
  if (CCTV_POPUP_RESERVED_SEGMENTS.has(decoded.toLowerCase())) {
    return <Navigate to="/central-control" replace />;
  }

  if (mode !== 'grid' && mode !== 'rotation') {
    return <Navigate to="/central-control" replace />;
  }

  return (
    <PoolAccessGuard>
      <CctvPoolMonitoringPopupPage />
    </PoolAccessGuard>
  );
};

export default CctvShortPoolPopupRoute;
